<template>
    <div class="kit-progress">
        <figure></figure>
    </div>
</template>

<script>
    export default {
        name: 'ProgressBar',
        data() {
            return {
                width: '0%'
            }
        },
        watch: {
            '$store.state.step': function() {
                this.width = (this.$store.state.step * 100) / this.$store.state.current.groups.length + '%';
            }
        }
    }
</script>

<style lang="scss">
    .kit {
        &-progress {
            border-radius: 100px;
            background: #EFEFEF;
            height: 13px;
            position: relative;
            overflow: hidden;

            figure {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                background-color: #1D1E42;
                width: v-bind('width');
                transition: width .5s cubic-bezier(0.165, 0.84, 0.44, 1);
            }
        }
    }
</style>